export const typesPedidoVenta = {
  dataLoading: "[pedidoventa] PedidoVenta data Loading",
  pedidosventasLoaded: "[pedidoventa] Pedidos Ventas Loaded",
  pedidoventaSetActive: "[pedidoventa] pedidoventa Set Active",
  pedidoventaClearActive: "[pedidoventa] pedidoventa Clear Active",
  detallePedidoVentaSetActive: "[pedidoventa] detalle pedidoventa Set Active",
  detallePedidoVentaClearActive:
    "[pedidoventa] detalle pedidoventa Clear Active",
  pedidoventaAdded: "[pedidoventa] pedidoventa added",
  pedidoventaUpdated: "[pedidoventa] pedidoventa updated",
  pedidoventaDeleted: "[pedidoventa] pedidoventa deleted",
  pedidoventaLogout: "[pedidoventa] pedidoventa logout",
};
